import { Button, Modal, Space, Dropdown, Typography, Drawer } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { FaCaretDown } from "react-icons/fa";
import MainLayout from "../components/Layout/MainLayout";
import DataTable from "../components/Tables/Datatable";
import { getClientMenuItems, items, roleIds } from "../constant";
import SearchInput from "../components/Forms/SearchInput";
import { FiEdit2 } from "react-icons/fi";
import { useApiCall } from "../services/api";
import { useSelector } from "react-redux";
import { TbDotsVertical } from "react-icons/tb";
import {
  useNavigate,
  useSearchParams,
  useOutletContext,
} from "react-router-dom";
import Delete from "../components/models/Delete";
import Clientaccess from "../components/models/Clientaccess";
import { useGlobalModal } from "../context/SuccessModalProvider";
import Loader from "../common/Loader";
import PrimaryButton from "../components/Forms/PrimaryButton";
import Filters from "../components/Filters";
import { handleRouteNav } from "../utils";
import CustomBadge from "../components/Charts/CustomBadge";
import { PiProhibit } from "react-icons/pi";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import ConfirmModal from "../components/models/ConfirmModal";
import usePagination from "../hooks/usePagination";

const actionKeyMap = {
  BLOCK_CLIENT: "BLOCK_CLIENT",
};

const Client = () => {
  const { postApi, getApi, loading } = useApiCall();
  const [fetchLoading, setFetchLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalClients, setTotalClients] = useState(0);
  const {
    pagination,
    setPagination,
    handleChange: handlePaginationChange,
    resetPage,
  } = usePagination();
  const {
    is_sales_person,
    is_admin,
    is_sales_manager,
    role_id,
    full_name,
    user_id,
  } = useSelector((state) => state.auth);
  const [deleteId, setDeleteId] = useState(null);
  const [recordDetails, setRecordDetails] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModal, setIsDeleteModel] = useState(false);
  const [accessType, setAccessType] = useState(null);
  const [salesList, setSalesList] = useState([]);
  const [salesPerson, setSalesPerson] = useState(null);
  const { showPopup } = useGlobalModal();
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [modalAction, setModalAction] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const { appliedFilters, ModalUI, FilterButton } = Filters({
    filters: [
      {
        type: "select",
        key: "salesPerson",
        label: "Assigned Sales",
        options: salesList.map((sales) => ({
          label: sales.full_name,
          value: sales.user_id,
        })),
        inputProps: {
          placeholder: "Select Salesperson",
        },
      },
      is_admin && {
        type: "select",
        key: "status",
        label: "Status",
        options: [
          { label: "Active", value: 0 },
          { label: "Disabled", value: 1 },
        ],
        inputProps: {
          placeholder: "Select Status",
        },
      },
    ].filter(Boolean),
    onChange: () => resetPage(),
  });

  const handleChange = (paginationInfo, filters, sorter) => {
    handlePaginationChange(paginationInfo, filters, sorter);
  };

  const showModal = (type, id, record) => {
    setRecordDetails(record);
    console.log("record data here", id, record);
    setDeleteId(id);
    if (type == "Allow Edit Access") {
      setAccessType(type);
      setIsDeleteModel(true);
    } else if (type == "delete") {
      setAccessType(type);
      setIsDeleteModel(true);
    } else if (type == "Assign salesperson") {
      setAccessType(type);
      setIsModalVisible(true);
    }
  };

  const handleRow = (record) => {
    navigate(handleRouteNav("/client-profile", role_id), {
      state: { user_id: record.customer_id, routeType: "client" },
    });
  };

  // Dropdown action handler
  const handleMenuClick = (key, record) => {
    if (key === "EDIT") {
      handleRow(record);
      return;
    }

    if (key === "BLOCK") {
      setSelectedRecord(record);
      setModalAction(actionKeyMap.BLOCK_CLIENT);
      return;
    }
  };

  const handleConfirmAction = async (selectedRole, data) => {
    if (!modalAction || !selectedRecord) return;

    try {
      let res;
      if (modalAction === actionKeyMap.BLOCK_CLIENT) {
        res = await postApi(
          "sales/customers/block-unblock-status",
          {
            is_blocked: selectedRecord?.is_blocked ? 0 : 1,
            updated_by: full_name,
            updated_by_id: user_id,
            customer_id: selectedRecord?.customer_id,
          },
          true,
        );
      }

      if (res && res?.status) {
        setModalAction(null);
        setSelectedRecord(null);
        fetchClients();
      }
    } catch (err) {
      console.error("action error:", err);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "customer_id",
      key: "customer_id",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "Location",
      dataIndex: "state",
      key: "state",
      render: (_, record) => {
        // Check if customer_address exists and has default delivery
        const defaultDelivery = record.customer_address?.find(
          (addr) => addr.is_default_delivery === 1,
        );

        const city = defaultDelivery?.city || record.city || "";
        const state = defaultDelivery?.state || record.state || "";

        return `${city}${city && state ? ", " : ""}${state}`;
      },
      // render: (_, record) => {
      //   const city = record.city || "";
      //   const state = record.state || "";
      //   return `${city}${city && state ? ", " : ""}${state}`;
      // },
      ellipsis: true,
    },
    is_admin && {
      title: "Status",
      dataIndex: "is_blocked",
      key: "is_blocked",
      ellipsis: true,
      render: (value) => {
        const statusNames = { 0: "Active", 1: "Disabled" };
        return (
          <CustomBadge
            variant={value ? "danger" : "success"}
            text={statusNames[value]}
          />
        );
      },
    },
    (is_sales_manager || is_admin) && {
      title: "Assigned Sales",
      dataIndex: "user",
      key: "user",
      render: (record) => record?.full_name || "Not Assigned",
      ellipsis: true,
    },
    {
      title: "",
      key: "action",
      width: 60,
      fixed: "right",
      render: (record) => (
        <>
          {is_sales_manager || is_admin ? (
            <Dropdown
              menu={{
                items: !is_admin
                  ? getClientMenuItems(record)
                  : [
                      {
                        key: "BLOCK",
                        label: (
                          <Space className="text-[#A33434] font-semibold">
                            <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
                              <PiProhibit />
                            </div>
                            {record.is_blocked
                              ? "Unblock Customer"
                              : "Block Customer"}
                          </Space>
                        ),
                      },
                      {
                        key: "EDIT",
                        label: (
                          <Space className="text-[#A33434] font-semibold">
                            <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
                              <MdOutlineEdit />
                            </div>
                            Edit Customer
                          </Space>
                        ),
                      },
                      {
                        key: 3,
                        label: (
                          <Space className="text-[#A33434] font-semibold">
                            <div className="bg-[#A33434] p-1.5 rounded-full text-[#ffffff]">
                              <RiDeleteBin6Line />
                            </div>
                            Delete Customer
                          </Space>
                        ),
                      },
                    ],
                onClick: ({ key, domEvent }) => {
                  domEvent.stopPropagation();
                  if (is_admin) {
                    handleMenuClick(key, record);
                  }
                  if (key == 2) {
                    showModal("Allow Edit Access", record.customer_id, record);
                  } else if (key == 3) {
                    showModal("delete", record.customer_id, record);
                  } else if (key == 1) {
                    showModal("Assign salesperson", record.customer_id, record);
                  }
                },
              }}
              trigger={["click"]}
              overlayClassName="custom-dropdown-sales-menu"
            >
              <Typography.Link
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <Space>
                  <TbDotsVertical className="text-red-700" size={18} />
                </Space>
              </Typography.Link>
            </Dropdown>
          ) : (
            <>
              {record?.is_edit_allowed ? (
                <img src="/assets/icons/PencilSimple.svg" />
              ) : null}
            </>
          )}
        </>
      ),
    },
  ].filter(Boolean);

  const handleOk = () => {
    console.log("Form submitted");
    setIsModalVisible(false);
  };

  const onSearch = (value, _e, info) => console.log(info?.source, value);

  const handlePending = async () => {
    navigate(handleRouteNav("/pending-clients", role_id));
  };

  const fetchIdRef = useRef(0);

  const fetchClients = useCallback(async () => {
    fetchIdRef.current += 1;
    const currentFetchId = fetchIdRef.current;
    try {
      setFetchLoading(true);
      const { salesPerson, status } = appliedFilters;

      const filters = {
        user_id: salesPerson,
        is_blocked: status,
      };

      const body = {
        per_page: pagination.pageSize,
        page: pagination.current,
        search: query,
        ...(is_sales_person && { user_id }),
        ...(Object.keys(appliedFilters).length ? filters : {}),
      };
      const res = await postApi(
        is_sales_manager
          ? "sales/customers/approved"
          : "sales/assign-customer-list",
        body,
      );

      if (currentFetchId !== fetchIdRef.current) {
        return;
      }

      setData(res.data || []);
      setTotalClients(res.total || 0);
    } catch (error) {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      console.error("Error fetching clients:", error);
    } finally {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      setFetchLoading(false);
    }
  }, [
    appliedFilters,
    is_sales_manager,
    is_sales_person,
    pagination.current,
    pagination.pageSize,
    query,
    user_id,
  ]);

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
    resetPage();
  };

  const fetchSalesList = async () => {
    const res = await getApi("sales/sales-person-dropdown-list");
    if (res && res.data) {
      setSalesList(res.data);
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchClients();
    }, 300);

    return () => clearTimeout(handler);
  }, [fetchClients]);

  useEffect(() => {
    fetchSalesList();
  }, []);

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsDeleteModel(false);
  };

  const handleDeleteOk = async () => {
    let res;
    if (accessType == "Allow Edit Access") {
      res = await postApi(
        "sales/customers/edit-allow",
        {
          customer_id: deleteId,
          is_edit_allowed: recordDetails.is_edit_allowed ? 0 : 1,
        },
        true,
      );
    } else {
      res = await postApi(
        "customer/delete",
        {
          customer_id: deleteId,
          updated_by_id: user_id,
          updated_by: full_name,
        },
        true,
      );
    }
    if (res && res?.status) {
      setIsDeleteModel(false);
      fetchClients();
    }
  };

  const handleSelect = (id) => {
    setSalesPerson(id);
  };

  const handleSubmit = async () => {
    if (!salesPerson) {
      return showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            Please select a salesperson.
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
    }
    if (recordDetails?.user?.user_id !== salesPerson) {
      let assignData = {
        user_id: salesPerson,
        customer_id: deleteId,
        updated_by: full_name,
        updated_by_id: user_id,
      };
      let response;
      if (accessType == "Assign salesperson") {
        response = await postApi("sales/assign-sales-person", assignData, true);
      }
      if (response?.data || response?.status) {
        handleCancel();
        fetchClients();
      }
    } else {
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            Salesperson re-assigned successfully.
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      handleCancel();
      fetchClients();
    }
  };

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle(is_admin ? "Customer Directory" : "Client List");
    setDescription(
      `${totalClients} total ${is_admin ? "customers" : "clients"}`,
    );
    setBackButton(is_admin);
  }, [setTitle, setDescription, setBackButton, totalClients]);

  return (
    <>
      <ModalUI />
      <>
        <div
          className="bg-[#FFFFFF]"
          style={{ borderRadius: "32px", overflow: "hidden" }}
        >
          <div className="flex flex-row justify-between items-center gap-3 w-full px-8 py-6">
            <SearchInput
              onSearch={onSearch}
              placeholder="Search for clients"
              value={query}
              onChange={handleOnSearchChange}
            />
            <div className="flex items-center gap-3">
              {(is_sales_manager || is_admin) && <FilterButton />}
              <PrimaryButton
                text="Pending Clients"
                onClick={handlePending}
                noIcon
              />
              <Button
                type="primary"
                className="h-[45px] bg-[#7070701A]  hover:!bg-[#7070701A] hover:!text-[#A33434] font-bold text-[#A33434] text-base !cursor-default"
              >
                {totalClients} clients
              </Button>
            </div>
          </div>
          {fetchLoading ? (
            <div className="flex justify-center items-center py-20">
              <Loader size={60} />{" "}
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data}
              handleChange={handleChange}
              handleRow={handleRow}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: totalClients,
                showSizeChanger: true,
              }}
            />
          )}
        </div>
      </>
      <Modal
        className="form-css-2"
        open={isModalVisible}
        onOk={handleOk}
        footer={null}
        onCancel={handleCancel}
      >
        <Clientaccess
          plainOptions={salesList}
          handleSubmit={handleSubmit}
          handleSelect={handleSelect}
          salesPerson={salesPerson}
          assignedSalesPerson={recordDetails?.user?.full_name}
          loading={loading}
        />
      </Modal>
      <Modal
        className="form-css-4"
        open={isDeleteModal}
        footer={null}
        onCancel={handleCancel}
      >
        <Delete
          text={accessType}
          handleSubmit={handleDeleteOk}
          closeModal={() => setIsDeleteModel(false)}
          assignedSalesPerson={recordDetails?.user?.full_name}
          pageName="Clients"
          recordName={recordDetails?.company_name}
          recordDetails={recordDetails}
          loading={loading}
        />
      </Modal>

      <ConfirmModal
        actionKey={modalAction}
        record={selectedRecord}
        open={modalAction === actionKeyMap.BLOCK_CLIENT}
        onCancel={() => {
          setModalAction(null);
          setSelectedRecord(null);
        }}
        onConfirm={handleConfirmAction}
        loading={loading}
      />
    </>
  );
};

export default Client;
